import { ComponentChildren, FunctionComponent } from 'preact';
import clsx from 'clsx';

import { Section } from './components/Section';

import styles from './Card.module.scss';

interface CardProps {
  children: ComponentChildren;
  sectioned?: boolean;
  /** Add round corners to card
   * @default true
   */
  rounded?: boolean;
  subdued?: boolean;
  tight?: boolean;
  classNames?: string[];
}

export const Card: FunctionComponent<CardProps> & {
  Section: typeof Section;
} = function Card({
  children,
  sectioned,
  rounded = true,
  subdued,
  tight,
  classNames = [],
}: CardProps) {
  const className = clsx(
    styles.Card,
    rounded && styles.rounded,
    subdued && styles.subdued,
    tight && styles.tight,
    ...classNames,
  );
  const contentMarkup = sectioned ? <Section>{children}</Section> : children;

  return <div className={className}>{contentMarkup}</div>;
};

Card.Section = Section;
